import React, { useEffect, useState } from "react";
import { Box, Button, Divider, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import frLocale from "date-fns/locale/fr";

import { useAppMutation } from "../../../services";
import adminServices from "../../../services/admin-services";

// Components
import Parents from "./parents";
import Students from "./students";
import Teachers from "./teachers";
import Subscriptions from "./subs";
import PlatformActivity from "./platform";

const Dashboard = () => {
  // Date state
  const [startDate, setStartDate] = useState(new Date("2024-04-01"));
  const [endDate, setEndDate] = useState(new Date("2024-04-24"));

  // API state
  const [stats, setStats] = useState(null);
  const {
    mutate: loadNumbers,
    isSuccess,
    data,
    isError,
    isLoading,
  } = useAppMutation(adminServices.loadDataNumbers);

  useEffect(() => {
    loadNumbers();
  }, []);

  useEffect(() => {
    if (isSuccess && data) {
      console.log("dataDashboard----", data);
      setStats(data);
    }
  }, [isSuccess, data]);

  const handleApply = () => {
    console.log("Date range applied:", startDate, endDate);
    // here you can call API again with startDate, endDate
    loadNumbers({ startDate, endDate });
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Top filter */}
      {/*<Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 2,
          mb: 3,
        }}
      >
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={frLocale}
        >
          <DatePicker
            label="Début"
            value={startDate}
            onChange={(newValue) => setStartDate(newValue)}
          />
          <DatePicker
            label="Fin"
            value={endDate}
            onChange={(newValue) => setEndDate(newValue)}
          />
        </LocalizationProvider>

        <Button variant="contained" onClick={handleApply}>
          Appliquer
        </Button>
      </Box>*/}
      {/* Parents */}
      <Typography variant="h6" mb={1}>
        Parents
      </Typography>
      <Parents stats={stats} loading={isLoading} isError={isError} />
      <Divider sx={{ mb: 3 }} />
      {/* Students */}
      <Typography variant="h6" mb={1}>
        Students
      </Typography>
      <Students stats={stats} loading={isLoading} isError={isError} />
      <Divider sx={{ mb: 3 }} />
      {/* Teachers */}
      <Typography variant="h6" mb={1}>
        Teachers
      </Typography>
      <Teachers stats={stats} loading={isLoading} isError={isError} />
      <Divider sx={{ mb: 3 }} />
      {/* Subscriptions */}
      {/*<Typography variant="h6" mb={1}>
        Abonnements et Packs
      </Typography>
      <Subscriptions />

      <Divider sx={{ mb: 3 }} />


      <Typography variant="h6" mb={1}>
        Activité Plateforme
      </Typography>
      <PlatformActivity />
      */}
    </Box>
  );
};

export default Dashboard;
